import React from "react";
import { Tabs } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../shared/PageHeader";
import AssetsTab from "./AssetsTab";
import CashbookTab from "./CashbookTab";
import TravelTab from "./TravelTab";

// /user/accounting/assets/:tab? — Anlagen, Kassenbuch, Reisekosten
const AssetsAndCash = () => {
  const { t } = useTranslation("accounting");
  const history = useHistory();
  const match = useRouteMatch("/user/accounting/assets/:tab?");
  const active = match?.params?.tab || "anlagen";
  return (
    <div>
      <PageHeader
        title={t("Fixed assets & cash book")}
        subtitle={t("Anlagenverzeichnis, AfA, Kassenbuch und Reisekosten")}
      />
      <Tabs
        activeKey={active}
        onChange={key => history.push(`/user/accounting/assets/${key}`)}
        destroyInactiveTabPane
        items={[
          { key: "anlagen", label: t("Fixed assets"), children: <AssetsTab /> },
          { key: "cashbook", label: t("Cash book"), children: <CashbookTab /> },
          { key: "travel", label: t("Travel expenses"), children: <TravelTab /> }
        ]}
      />
    </div>
  );
};

export default AssetsAndCash;
